import {resolvePromise} from "./lib";
import printHelper from "./printHelper"

window.rmtw = {

  setMenuItemToActive(menuId, activeString = null) {
    this.ready(() => {
      const active = activeString ?? 'active';
      const itemId = menuId.replace(/\//g, "-")

      const menuItem = document.querySelector('#menu-item-' + itemId)
      const mobileMenuItem = document.querySelector('#menu-item-mobile-' + itemId)

      menuItem &&  menuItem.classList.add('menu-' + active)
      mobileMenuItem && mobileMenuItem.classList.add('mobile-menu-' + active)
    });
  },

  ready(callback) {
    if (document.readyState !== "loading") {
      callback();
    }
    else {
      document.addEventListener("DOMContentLoaded", callback);
    }
  },

  redirect(url) {
    window.location.href = url;
  },

  elementFullyInScreen(elementString) {
    this.ready(() => {
      var observer = new IntersectionObserver(function (entries) {

        // isIntersecting is true when element and viewport are overlapping
        // isIntersecting is false when element and viewport don't overlap
        if (entries[0].isIntersecting === true) {
          return true;
        }

        if (entries[0].isIntersecting === false) {
          return false;
        }

      }, {
        threshold: [1]
      });

      document.querySelectorAll(elementString).forEach(element => {
        observer.observe(element)
      });
    })
  },

  getScrollPosition() {
    if (window.pageYOffset != undefined) {
      return [pageXOffset, pageYOffset];
    }
    else {
      var sx, sy, d = document,
        r = d.documentElement,
        b = d.body;
      sx = r.scrollLeft || b.scrollLeft || 0;
      sy = r.scrollTop || b.scrollTop || 0;
      return [sx, sy];
    }
  },

  createStyledFixedMenu(element, options) {

    const defaultHeight = options.defaultHeight ? options.defaultHeight : 40;
    const scrollHeight = options.scrollHeight ? options.scrollHeight : 24;
    const startPoint = options.startPoint ? options.startPoint : 150;
    const resetPoint = options.resetPoint ? options.resetPoint : 50;

    window.onscroll = () => {

      // change the menu while scrolling
      // (e.g. white + make it thinner)
      // this has a max - threshold for the event
      // so it does not trigger all the time while scrolling
      if (rmtw.getScrollPosition()[1] >= startPoint && rmtw.getScrollPosition()[1] <= 1000) {

        element.classList.remove('h-' + defaultHeight);
        // document.querySelector('.page-container').classList.remove('-mt-' +
        // defaultHeight);
        document.querySelector('.head-logo').classList.remove('h-' + defaultHeight, 'w-' + defaultHeight);

        document.querySelector('.head-logo').classList.add('h-' + scrollHeight, 'w-' + scrollHeight);
        // document.querySelector('.page-container').classList.add('-mt-' +
        // scrollHeight);
        element.classList.add('bg-neutral-ff', 'shadow', 'h-' + scrollHeight);

      }

      // set the menu to the start (transparent + big)
      if (rmtw.getScrollPosition()[1] < resetPoint) {

        element.classList.remove('bg-neutral-ff', 'shadow', 'h-' + scrollHeight)
        // document.querySelector('.page-container').classList.remove('-mt-' +
        // scrollHeight);
        document.querySelector('.head-logo').classList.remove('h-' + scrollHeight, 'w-' + scrollHeight);

        document.querySelector('.head-logo').classList.add('h-' + defaultHeight, 'w-' + defaultHeight);
        // document.querySelector('.page-container').classList.add('-mt-' +
        // defaultHeight);
        element.classList.add('h-' + defaultHeight);

      }
    }


    // runs if the page is loaded
    // needed for the none-transparent menu
    // if users refresh the page
    // in the middle of the page
    window.onload = function () {
      if (rmtw.getScrollPosition()[1] > startPoint) {
        element.classList.remove('h-' + defaultHeight);
        // document.querySelector('.page-container').classList.remove('-mt-' +
        // defaultHeight);
        document.querySelector('.head-logo').classList.remove('h-' + defaultHeight, 'w-' + defaultHeight);

        document.querySelector('.head-logo').classList.add('h-' + scrollHeight, 'w-' + scrollHeight);
        // document.querySelector('.page-container').classList.add('-mt-' +
        // scrollHeight);
        element.classList.add('bg-neutral-ff', 'shadow', 'h-' + scrollHeight);
      }
    }

  },

  // resolves a promise and send back an array with date and null, or null and an error
  // if an error appears it will print it to the console with console.log
  async resolvePromise(callback) {
    return resolvePromise(callback)
  },

  print: printHelper

}
